<template>
  <a-alert
    v-if="show"
    :icon="null"
    :message="
      $t(
        'ru-guo-yu-dao-wang-ye-wu-fa-zheng-chang-jia-zai-huo-zhe-xian-shi-you-wen-ti-ke-neng-shi-you-yu-liu-lan-qi-bu-jian-rong-dao-zhi-jian-yi-shi-yong-chrome-liu-lan-qi-jin-hang-fang-wen',
      )
    "
    class="compatibility"
    type="info"
    closable
    @close="handleClose"
  />
</template>
<script setup lang="ts">
import { COOKIE_KEY } from '~/constants/config';
const { isChrome, isEdge } = useDevice();

const show = computed(() => {
  const isHinted = localGetItem(COOKIE_KEY.COMPATIBILITY_HINT) || false;
  return !isHinted && !isChrome && !isEdge;
});

const handleClose = () => {
  localSetItem(COOKIE_KEY.COMPATIBILITY_HINT, true);
};
</script>

<style scoped lang="scss">
.compatibility {
  margin: 8px 4px 4px;
}
</style>
